module.exports = __webpack_public_path__ + "d0c4ea3446bd1784e427c8302b4fcb72.pdf";